import { Location } from "../../../../../../../common/models";

interface LocationTreeSelectValueTemplateProps {
    location?: Location;
}

const LocationTreeSelectValueTemplate = (
    props: LocationTreeSelectValueTemplateProps
) => {
    const { location } = props;

    return <span className="text-text-500">{location?.name}</span>;
};

export default LocationTreeSelectValueTemplate;
